import { render, staticRenderFns } from "./verificar_documento.vue?vue&type=template&id=40efad8b&scoped=true"
import script from "./verificar_documento.vue?vue&type=script&lang=js"
export * from "./verificar_documento.vue?vue&type=script&lang=js"
import style0 from "./verificar_documento.vue?vue&type=style&index=0&id=40efad8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40efad8b",
  null
  
)

export default component.exports